import { Injectable, signal } from "@angular/core";
import { ToastPosition } from "../interfaces/toast.interfaces";
import { ToastConfig } from "../notifications-alert.component";

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationAlertService {
  private toastsSubject = new BehaviorSubject<ToastConfig[]>([]);
  public toasts$: Observable<ToastConfig[]> = this.toastsSubject.asObservable();

  notifications = [{
    id:1,
    title:"Test",
    description:"test",
    date:new Date()
  },
{
    id:1,
    title:"Test",
    description:"test",
    date:new Date()
  },
{
    id:1,
    title:"Test",
    description:"test",
    date:new Date()
  },{
    id:1,
    title:"Test",
    description:"test",
    date:new Date()
  }];

  // Método principal para mostrar una notificación
 show(config: Partial<ToastConfig>): void {
    const newToast: ToastConfig = {
      // Valores por defecto
      id: Date.now() + Math.random(), // ID único
      type: 'info',
      isClosable: true,
      duration: 5000, // 5 segundos por defecto
      position: 'top-right',
      // Sobrescribimos con la configuración proporcionada
      ...config,
    };

    // Obtenemos la lista actual, añadimos el nuevo toast y emitimos.
    const currentToasts = this.toastsSubject.getValue();
    this.toastsSubject.next([...currentToasts, newToast]);
  }
  remove(id: number): void {
    const updatedToasts = this.toastsSubject.getValue().filter(toast => toast.id !== id);
    this.toastsSubject.next(updatedToasts);
  }

  // --- Métodos de ayuda para tipos comunes ---
  showSuccess(title: string, description?: string, options?: Partial<ToastConfig>): void {
    this.show({ ...options, title, description, type: 'success' });
  }

  showError(title: string, description?: string, options?: Partial<ToastConfig>): void {
    this.show({ ...options, title, description, type: 'error', duration: 7000 }); // Más tiempo para errores
  }

  showWarning(title: string, description?: string, options?: Partial<ToastConfig>): void {
    this.show({ ...options, title, description, type: 'warning' });
  }

  showInfo(title: string, description?: string, options?: Partial<ToastConfig>): void {
    this.show({ ...options, title, description, type: 'info' });
  }
}